import styles from "./index.module.scss";

export interface TagProps {
  icon: string;
  value: string | number;
  text: string;
}
const Tag = ({ icon, text, value }: TagProps) => {
  if (!value) {
    return null;
  }
  return (
    <div className={styles.tag}>
      <img src={icon} className={styles.icon} alt="" />
      <div className={styles.text}>
        {value}
        {text}
      </div>
    </div>
  );
};

export default Tag;
